import { ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";

export default function BagButton() {
  const { count, setOpen } = useCart();
  return (
    <button type="button" data-testid="nav-bag-btn" onClick={() => setOpen(true)} aria-label="Open bag"
      className="group relative inline-flex items-center gap-2 rounded-full border border-ink/70 px-3.5 py-1.5 text-ink transition-colors duration-300 hover:bg-ink hover:text-paper">
      <ShoppingBag className="h-3.5 w-3.5" strokeWidth={1.5} />
      <span className="overline text-[0.6rem]">Bag</span>
      <span data-testid="nav-bag-count" className="font-mono text-[0.6rem]">{count}</span>
    </button>
  );
}
